import { createContext } from 'react';
import type { useDialogContextProvider } from './use-dialog-context-provider';

export const DialogContext = createContext<ReturnType<
  typeof useDialogContextProvider
> | null>(null);
